export const JsonContentType = { 'Content-Type': 'application/json' }
export const formContentType = { 'Content-Type': 'multipart/form-data' }
